<template>
  <writer-profile :user-id="currentUser.id" />
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import WriterProfile from '@/components/commons/WriterProfile'
import { mapState } from 'vuex'

export default {
  components: {
    WriterProfile
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'プロフィール設定'
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>

<style scoped></style>
